const ColoredPrediction = (props) => {
    let color = props?.prediction?.color;
    if (color === 'green') {
        color = '#80B7AE'
    }else if (color === 'red') {
        color = '#EABBBB'
    }
    return (
        <div style={{ background: color }}>
            {props?.prediction?.advice}
        </div>
    )
}

export default ColoredPrediction;